import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiShield, FiGlobe, FiTrendingUp, FiBriefcase, FiCheckCircle } from 'react-icons/fi';
import './Home.css';

const Home = () => {
  const pillars = [
    {
      icon: <FiGlobe />,
      title: 'Energy & Oil',
      description: 'Strategic guidance for upstream, midstream, and downstream energy, including JVs, acquisitions, and structured transactions.'
    },
    {
      icon: <FiBriefcase />,
      title: 'Commodities & Mining',
      description: 'Advisory for commodity-linked investments and infrastructure projects, focusing on logistics and strategic positioning.'
    },
    {
      icon: <FiTrendingUp />,
      title: 'Real Estate & Real Assets',
      description: 'Institutional real estate advisory for commercial, industrial, and mixed-use developments with cross-border expertise.'
    },
    {
      icon: <FiShield />,
      title: 'Cross-Sector Joint Ventures',
      description: 'Facilitating multi-party partnerships and consortiums across industries and geographies with capital partners.'
    }
  ];

  const principles = [
    'Confidentiality and discretion in all engagements',
    'Independent advisory mandate—no proprietary positions',
    'Institutional standards of due diligence and structure',
    'Cross-border transaction expertise'
  ];

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-particles"></div>
        <div className="container">
          <div className="hero-content">
            <span className="hero-tagline">CRESCENT ADVISORY LTD</span>
            <h1 className="hero-title">
              Strategic Advisory.
              <span className="gradient-text"> Global Impact.</span>
            </h1>
            <p className="hero-subtitle">
              Independent intermediary and strategic advisor across global energy, commodities, 
              real estate, and joint venture transactions. We facilitate alignment between 
              principals, investors, and counterparties seeking structured opportunities in 
              complex asset classes.
            </p>
            <div className="hero-buttons">
              <Link to="/advisory-scope" className="btn-primary">
                Explore Our Scope
                <FiArrowRight />
              </Link>
              <Link to="/contact" className="btn-secondary">
                Schedule Consultation
              </Link>
            </div>
          </div>
        </div>
       
      </section>

      {/* Proposition Section */}
      <section className="proposition-section">
        <div className="container">
          <div className="proposition-grid">
            <div className="proposition-content fade-in">
              <h2 className="section-title">The Crescent Proposition</h2>
              <p className="proposition-text">
                We bridge capital and opportunity through discreet, institutional-grade 
                advisory for high-net-worth and corporate clients, facilitating complex 
                global transactions with precision and confidentiality. Our mandate is 
                advisory coordination and counterparty qualification, not direct transaction 
                participation unless expressly agreed in writing.
              </p>
              <div className="principles-list">
                {principles.map((principle, index) => (
                  <div key={index} className="principle-item">
                    <FiCheckCircle className="principle-icon" />
                    <span>{principle}</span>
                  </div>
                ))}
              </div>
             
            </div>
            <div className="proposition-visual slide-in-right">
              <div className="visual-grid">
                <div className="visual-card">
                  <h4>Independent</h4>
                  <p>No proprietary positions</p>
                </div>
                <div className="visual-card">
                  <h4>Discreet</h4>
                  <p>Strict confidentiality</p>
                </div>
                <div className="visual-card">
                  <h4>Institutional</h4>
                  <p>Standards of excellence</p>
                </div>
                <div className="visual-card">
                  <h4>Global</h4>
                  <p>Cross-border expertise</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pillars Section */}
      <section className="pillars-section">
        <div className="container">
          <h2 className="section-title center">The Four Pillars</h2>
          <p className="section-subtitle center">
            Specialized advisory across core sectors with institutional-grade expertise
          </p>
          <div className="pillars-grid">
            {pillars.map((pillar, index) => (
              <div key={index} className="pillar-card scale-in">
                <div className="pillar-icon-wrapper">
                  <div className="pillar-icon">{pillar.icon}</div>
                </div>
                <h3 className="pillar-title">{pillar.title}</h3>
                <p className="pillar-description">{pillar.description}</p>
                <Link to="/advisory-scope" className="pillar-link">
                  Learn More <FiArrowRight />
                </Link>
                <div className="pillar-number">0{index + 1}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Snapshot */}
      <section className="process-snapshot">
        <div className="container">
          <h2 className="section-title center">Engagement Lifecycle</h2>
          <p className="section-subtitle center">
            A structured approach to strategic advisory and deal facilitation
          </p>
          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">01</div>
              <div className="step-content">
                <h3>Initial Qualification</h3>
                <p>Confidential discussion under NDA to assess mandate, capacity, and alignment</p>
              </div>
              <div className="step-arrow">
                <FiArrowRight />
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">02</div>
              <div className="step-content">
                <h3>Documentation Review</h3>
                <p>Exchange of credentials, proof of funds, corporate structure, and regulatory standing</p>
              </div>
              <div className="step-arrow">
                <FiArrowRight />
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">03</div>
              <div className="step-content">
                <h3>Strategic Coordination</h3>
                <p>Structured introductions, due diligence support, and transaction guidance</p>
              </div>
              <div className="step-arrow">
                <FiArrowRight />
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">04</div>
              <div className="step-content">
                <h3>Execution & Stewardship</h3>
                <p>Transaction guidance through close and beyond with ongoing value optimization</p>
              </div>
            </div>
          </div>
         <div className="home-process-cta-wrapper">
  <div className="home-process-cta">
    <Link to="/engagement-process" className="home-process-cta-button">
      View Detailed Process
      <FiArrowRight />
    </Link>
  </div>
</div>

        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content scale-in">
            <h2>Ready to explore strategic alignment?</h2>
            <p>Qualified parties may submit a capability statement and proof of capacity under existing NDA. All inquiries are handled with strict confidentiality and professionalism.</p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn-primary">
                Initiate Confidential Discussion
                <FiArrowRight />
              </Link>
              <Link to="/investor-portal" className="btn-outline">
                Access Investor Portal
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;